import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBoth = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.78033 5.96967C7.48744 5.67678 7.01256 5.67678 6.71967 5.96967L1.46967 11.2197C1.17678 11.5126 1.17678 11.9874 1.46967 12.2803L6.71967 17.5303C7.01256 17.8232 7.48744 17.8232 7.78033 17.5303C8.07322 17.2374 8.07322 16.7626 7.78033 16.4697L3.81066 12.5H20.1893L16.2197 16.4697C15.9268 16.7626 15.9268 17.2374 16.2197 17.5303C16.5126 17.8232 16.9874 17.8232 17.2803 17.5303L22.5303 12.2803C22.8232 11.9874 22.8232 11.5126 22.5303 11.2197L17.2803 5.96967C16.9874 5.67678 16.5126 5.67678 16.2197 5.96967C15.9268 6.26256 15.9268 6.73744 16.2197 7.03033L20.1893 11H3.81066L7.78033 7.03033C8.07322 6.73744 8.07322 6.26256 7.78033 5.96967Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowBoth;
